<div class="input-group class-picker">
  <input type="text" [(ngModel)]=value (focus)="onInput()" (blur)="setWidgetClass()" class="form-control"/>
  <div dropdown class="input-group-btn" [insideClick]="true">
    <button dropdownToggle type="button" class="btn btn-default dropdown-toggle"><i class="wms wms-list"></i></button>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
      <ng-template role="menuitem" ngFor let-className [ngForOf]="widgetClasses" [ngForTrackBy]="trackByFn">
        <li class="role-selector"><input type="checkbox" [(ngModel)]=className.checked (change)="toggleClass(className)"/><span class="title" title="{{className.name}}">{{className.name}}</span></li>
      </ng-template>
    </ul>
  </div>
</div>
